import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hot } from 'react-hot-loader/root';

import withErrorHandler from '../../hoc/withErrorHandler';
import axios from '../../shared/axios/axios';

import { Modal, Button } from 'antd';

import * as actions from './store/actions/index';

import { PdfViewerComponent } from '../../shared/components/pdf-viewer/index';

import { PDFDocument } from 'pdf-lib';

import './style.less';

let root;

const CoverPageComponent = ({ rootContainer, onChange }) => {
  root = rootContainer;

  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [coverPageForm, setCoverPageForm] = useState();
  const [isSaved, setIsSaved] = useState(false);

  const file = useSelector((state) => state.coverPage.file);

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleModalSave = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsModalVisible(false);
    setIsSaved(true);

    const fileDataBytes = new Uint8Array(await coverPageForm());

    const pdfDoc = await PDFDocument.load(fileDataBytes);

    let form = pdfDoc.getForm();

    let queryParameters = {
      CompanyName: '',
      Address: '',
      Phone: '',
      Fax: '',
      To: '',
      ToFaxNumber: '',
      Date: '',
      From: '',
      FromFaxNumber: '',
      Memo: '',
    };

    if (form) {
      queryParameters = {
        CompanyName: form.getField('topmostSubform[0].Page1[0].txtCompanyName[0]').getText() || '',
        Address: form.getField('topmostSubform[0].Page1[0].txtAddress[0]').getText() || '',
        Phone: form.getField('topmostSubform[0].Page1[0].txtPhone[0]').getText() || '',
        Fax: form.getField('topmostSubform[0].Page1[0].txtFax[0]').getText() || '',
        To: form.getField('topmostSubform[0].Page1[0].txtTo[0]').getText() || '',
        ToFaxNumber: form.getField('topmostSubform[0].Page1[0].txtToFaxNumber[0]').getText() || '',
        Date: form.getField('topmostSubform[0].Page1[0].txtDate[0]').getText() || '',
        From: form.getField('topmostSubform[0].Page1[0].txtFrom[0]').getText() || '',
        FromFaxNumber: form.getField('topmostSubform[0].Page1[0].txtFromFaxNumber[0]').getText() || '',
        Memo: (form.getField('topmostSubform[0].Page1[0].txtMemo[0]').getText() || '').replace('123NewLine123', '\n'),
      };
    }

    const xmlResult = serializeToXml(queryParameters);

    if (typeof onChange === 'function') {
      onChange(xmlResult); //default Form.Item method to get value
    } else {
      const input = document.getElementById('coverPageOptionsInput');

      if (input) {
        input.value = xmlResult;
      }
    }
  };

  const handleshowModal = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsModalVisible(true);

    if (!isSaved) dispatch(actions.getCoverPage());
  };

  const serializeToXml = (obj) => {
    let xml = '<?xml version="1.0" encoding="utf-16"?><CoverPage>';

    for (const [key, value] of Object.entries(obj)) {
      xml += `<${key}>${value || ''}</${key}>`;
    }

    xml += '</CoverPage>';

    return xml;
  };

  return (
    <div>
      {typeof onChange === 'function' ? (
        <Button type="primary" onClick={handleshowModal}>
          View/Edit Cover Page
        </Button>
      ) : (
        <button className="view-edit-cover-page-button" onClick={handleshowModal}>
          View/Edit Cover Page
        </button>
      )}
      <Modal
        width={1200}
        className="cover-page-modal"
        title="Fax Cover Page"
        open={isModalVisible}
        getContainer={root}
        onCancel={handleModalCancel}
        footer={[
          <Button key="save" type="primary" onClick={handleModalSave} className="modal-save-button">
            Save Cover Page
          </Button>,
        ]}
      >
        <PdfViewerComponent fileBytes={file} rootContainer={root} registerFormSaveCallback={(callback) => setCoverPageForm(() => callback)} />
      </Modal>
    </div>
  );
};

export default hot(withErrorHandler(CoverPageComponent, axios, root));
